/**
 * Component: Site Header
 * -----------------------------------------------------------------------------
 * Logic related to site header.
 * @namespace siteHeader
 */

import classes from '~/config/classes'

/**
 * DOM selectors.
 */
const selectors = {
  announcementBar: '[data-announcement-wrapper]',
  meganavCallouts: '[js-site-header="meganavCallouts"]',
  meganavLinks: '[js-site-header="meganavLinks"]',
}

/**
 * Create a new siteHeader object.
 */
export default () => {

  /**
   * Node selectors.
   */
  const nodeSelectors = {
    announcementBar: document.querySelector(selectors.announcementBar),
    meganavCallouts: document.querySelectorAll(selectors.meganavCallouts),
    meganavLinks: document.querySelectorAll(selectors.meganavLinks),
  }

  /**
   * Handle meganav closed.
   */
  function handleMeganavClosed() {
    const { meganavCallouts, meganavLinks } = nodeSelectors

    meganavLinks.forEach((element) => element.classList.remove(classes.active))
    meganavCallouts.forEach((element) => element.classList.remove(classes.active))
  }

  /**
   * Handle meganav open.
   */
  function handleMeganavOpen() {
    const { meganavCallouts, meganavLinks } = nodeSelectors

    setTimeout(() => {
      meganavLinks.forEach((element) => element.classList.add(classes.active))
    }, 400)

    setTimeout(() => {
      meganavCallouts.forEach((element) => element.classList.add(classes.active))
    }, 600)
  }

  /**
   * Set event bus listeners.
   */
  function setEventBusListeners() {
    window.basis.EventBus.listen('meganav-open', () => handleMeganavOpen())
    window.basis.EventBus.listen('meganav-closed', () => handleMeganavClosed())
  }

  /**
   * Check if announcement bar is enabled, set root style.
   */
  function setMenuDrawerTop() {
    if (!nodeSelectors.announcementBar) {
      return
    }

    const root = document.querySelector(':root')
    const height = `${nodeSelectors.announcementBar.offsetHeight}px`

    root.style.setProperty('--menu-drawer-top', height)
  }

  /**
   * Initialize component.
   */
  function init() {
    setMenuDrawerTop()
    setEventBusListeners()
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  })
}
